import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  FormControl,
  InputLabel,
  Button,
  Typography,
} from "@mui/material";
// import { ReactComponent as FileDownload } from "@deere/ux.brand-foundations/icons/file_download.svg";
import axios from "axios";
import { useOktaAuth } from "@okta/okta-react";
import RenderStatus from "../as2-summary-table/RenderStatus";
import RenderDirection from "../as2-summary-table/RenderDirection";
import PropTypes from "prop-types";

const As2DetailForm = (props) => {
  const initialDocStatus = {
    document_id: undefined,
    direction: undefined,
    refNum: undefined,
    refType: undefined,
    refValue: undefined,
    createDate: undefined,
    lastUpdateDate: undefined,
    standard: undefined,
    intSndrQual: undefined,
    intSndrId: undefined,
    intRcvrQual: undefined,
    intRcvrId: undefined,
    intCntrlNum: undefined,
    grpSndrId: undefined,
    grpRcvrId: undefined,
    funcGrpId: undefined,
    grpCntrlNum: undefined,
    transSetId: undefined,
    transSetCntrlNum: undefined,
    status: undefined,
    trackingNum: undefined,
    sourceApp: undefined,
    destApp: undefined,
    clientId: undefined,
    sid: undefined,
    supplierId: undefined,
    sndprn: undefined,
    rcvprn: undefined,
    port: undefined,
    envelopeName: undefined,
    appFileArchive: undefined,
    ediFileArchive: undefined,
    filesize: undefined,
    applMailbox: undefined,
    intDate: undefined,
    grpDate: undefined,
    intTestInd: undefined,
    sndprt: undefined,
    rcvprt: undefined,
    sndpor: undefined,
    rcvpor: undefined,
    mestyp: undefined,
    docrel: undefined,
    idocType: undefined,
    faKey: undefined,
    company: undefined,
    batchId: undefined,
    envelopeSeq: undefined,
    asnflag: undefined,
    plantcode: undefined,
    packlist: undefined,
    po: undefined,
    trackingNbr: undefined,
    licensePlate: undefined,
    kanban: undefined,
    partNbr: undefined,
    docStatusLabel: undefined,
    transactionTypeName: undefined,
    formattedDocStatusCreatedDateTime: undefined,
    formattedDocStatusLastUpdateDateTime: undefined,
    id: undefined,
    messageId: undefined,
    senderAs2Id: undefined,
    receiverAs2Id: undefined,
    supplierNum: undefined,
    unit: undefined,
    envelopeKey: undefined,
    archivePath: undefined,
    createDateTime: undefined,
    as2Status: undefined,
    mdnMessageId: undefined,
    mdnAck: undefined,
    mdnTransStatus: undefined,
    updateDateTime: undefined,
    formattedCreatedDateTime: undefined,
    directionLabel: undefined,
    asStatusAsNumber: undefined,
  };
  const as2CommStatusDetails = props.details;
  const as2CommStatusId = as2CommStatusDetails.id;
  const { oktaAuth } = useOktaAuth();
  const [documentStatus, setDocumentStatus] = useState(initialDocStatus);

  useEffect(() => {
    const fetchDocumentStatus = async (queryString) => {
      return await axios.get(
        process.env.REACT_APP_EDI_AS2_COMMUNICATION_STATUS_BASE_URL +
          queryString,
        {
          headers: {
            Authorization: "Bearer " + oktaAuth.getAccessToken(),
          },
        }
      );
    };

    const queryString = `/api/as2/document-status?envelopeKey=${as2CommStatusDetails.envelopeKey}`;

    fetchDocumentStatus(queryString)
      .then((response) => {
        let data = response?.data;
        if (data.length > 0) {
          let docStatus = data[0];
          delete docStatus["envelopeKey"];
          docStatus["document_id"] = docStatus["id"];
          delete docStatus["id"];
          setDocumentStatus({ ...docStatus, ...as2CommStatusDetails });
        } else {
          setDocumentStatus(initialDocStatus);
        }
      })
      .catch((error) => {
        console.log(error, error?.response);
      });
/*       const newDocumentList = 
  {
    id: "d8a52f103cf5488f95dc494d38b51719",
    direction: 1,
    refNum: null,
    refType: "ShipmentID",
    refValue: "6314822",
    createDate: "2025-07-25T13:06:13.000+00:00",
    lastUpdateDate: "2025-07-25T13:06:28.000+00:00",
    standard: true,
    intSndrQual: "01",
    intSndrId: "007061617",
    intRcvrQual: "01",
    intRcvrId: "149825353",
    intCntrlNum: "9559851",
    grpSndrId: "089233126",
    grpRcvrId: "149825353",
    funcGrpId: "SH",
    grpCntrlNum: "3563240",
    transSetId: "856",
    transSetCntrlNum: "1",
    status: 12,
    trackingNum: "565308075_94802019841b0f483node2",
    sourceApp: null,
    destApp: null,
    clientId: null,
    sid: null,
    supplierId: "0000002284",
    sndprn: null,
    rcvprn: null,
    port: null,
    envelopeName: "SAPPAG_AG00_0000002284_856_004010_ST_R",
    appFileArchive: "/app_data/B2Bi/archives/202507/25/SAP_PAG_410_4_toSAP/565308259_31247119841b12a9fnode2",
    ediFileArchive: "/app_data/B2Bi/archives/202507/25/EDI_GATES_IN/565308060_59189719841b0f483node2",
    filesize: 585,
    applMailbox: "/app_data/B2Bi/mailbox/EDI_GATES/Inbound/SI_20250725_257047000.edi",
    intDate: "2025-07-25T12:06:00.000+00:00",
    grpDate: "2025-07-25T12:06:00.000+00:00",
    intTestInd: "P",
    sndprt: null,
    rcvprt: null,
    sndpor: null,
    rcvpor: null,
    mestyp: null,
    docrel: null,
    idocType: null,
    faKey: null,
    company: "GA",
    batchId: null,
    envelopeSeq: 1,
    asnflag: "AA",
    plantcode: null,
    packlist: null,
    po: "5501232585",
    trackingNbr: null,
    licensePlate: null,
    kanban: null,
    partNbr: "FH339834",
    envelopeKey: "7965f533b9c74ffeb075a48ff0e6babf",
    transactionTypeName: "Advanced Shipping Notice",
    docStatusLabel: "REPROCESSED",
    formattedDocStatusCreatedDateTime: "2025-07-25 08:06:13",
    formattedDocStatusLastUpdateDateTime: "2025-07-25 08:06:28"
  }
;

// Asignar la lista al estado
setDocumentStatus(newDocumentList); */



  }, [as2CommStatusId]);
  const handlerDownloadFile = (documentId, fileType) => {
    const downloadFile = async (queryString) => {
      return await axios.get(
        process.env.REACT_APP_EDI_AS2_COMMUNICATION_STATUS_BASE_URL +
          queryString,
        {
          headers: {
            Authorization: "Bearer " + oktaAuth.getAccessToken(),
          },
        }
      );
    };
    const queryString = `/api/as2/document-status/file?documentId=${documentId}&type=${fileType}`;
    downloadFile(queryString)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const fileName =
          response.headers["content-disposition"].split("filename=")[1];
        link.setAttribute("download", fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log(error, error?.response);
      });
  };

  return (
    <form>
      <Box style={{ height:"100%"}}>
        <Grid alignItems="flex-start" container justifyContent="left">
          <Grid container size={12}>
            <Grid item >
              <Typography
                size="xl"
                component="p"
                fontWeight="bold"
                gutterBottom
              >
                {documentStatus.messageId
                  ? `Transaction Details - ${documentStatus.messageId}`
                  : "Transaction Details"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container size={12}>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  Id
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.id}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  AS2 Date/Time
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.formattedCreatedDateTime}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  AS2 Status
                </InputLabel>
                <RenderStatus value={documentStatus.as2Status} />
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  Direction
                </InputLabel>
                <RenderDirection value={documentStatus.directionLabel} />
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  AS2 Sender Id
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.senderAs2Id}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  AS2 Receiver Id
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.receiverAs2Id}
                </Typography>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container size={12}>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  ISA Sender Id
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.intSndrId
                    ? `${documentStatus.intSndrId}-${documentStatus.intSndrQual}`
                    : ""}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  ISA Receiver Id
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.intRcvrId
                    ? `${documentStatus.intRcvrId}-${documentStatus.intRcvrQual}`
                    : ""}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  GS Sender Id
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.grpSndrId}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  GS Receiver Id
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.grpRcvrId}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  ISA Cntrl Number
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.intCntrlNum}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  GS Cntrl Number
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.grpCntrlNum}
                </Typography>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container size={12}>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  Trans Cntrl Number
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.transSetCntrlNum}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  Type
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.transSetId &&
                  documentStatus.transactionTypeName
                    ? `${documentStatus.transSetId}-${documentStatus.transactionTypeName}`
                    : documentStatus.transSetId}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  Supplier
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.supplierNum}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  Unit
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.unit}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  Document Number
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.refNum}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  Reference Value
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.refValue}
                </Typography>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container size={12}>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  Doc Status{" "}
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.docStatusLabel}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  Doc Status Created
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.formattedDocStatusCreatedDateTime}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  Doc Status Updated
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.formattedDocStatusLastUpdateDateTime}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  SAP Landscape
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.envelopeName &&
                  documentStatus.envelopeName.substr(0, 3) === "SAP"
                    ? documentStatus.envelopeName.substr(0, 6)
                    : ""}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item size={2}>
              <FormControl fullWidth>
                <InputLabel style={{ fontWeight: "bold", fontSize: "small" }}>
                  Envelope
                </InputLabel>
                <Typography size="sm" component="p" gutterBottom>
                  {documentStatus.envelopeName}
                </Typography>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item size={4}>
              {documentStatus.ediFileArchive && (
                <Button
                  variant="text"
                  startIcon={<fuel-icon name={"download"} />}
                  onClick={(event) => {
                    event.preventDefault();
                    handlerDownloadFile(documentStatus.document_id, "EDI");
                  }}
                >
                  Download EDI Raw File
                </Button>
              )}
            </Grid>
            <Grid item size={4}>
              {documentStatus.appFileArchive && (
                <Button
                  variant="text"
                  startIcon={<fuel-icon name={"download"} />}
                  onClick={(event) => {
                    event.preventDefault();
                    handlerDownloadFile(documentStatus.document_id, "APP");
                  }}
                >
                  Download Application File
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};

As2DetailForm.propTypes = {
  details: PropTypes.object.isRequired,
};
export default As2DetailForm;
